// You can write more code here

import { getBackingFromWidth } from '@/game/GameComponents/PhaserGame/Utils/StudentGameUtils';
import StudentGameCard from '@/game/prefabs/StudentGame/StudentGameCard';

/* START OF COMPILED CODE */

export default class PlaceholderStudentGameCard extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		this.scaleX = 4;
		this.scaleY = 4;

		// minigameCardBacking
		const minigameCardBacking = scene.add.image(0, 0, "Card_48");
		minigameCardBacking.scaleX = 1.5;
		minigameCardBacking.scaleY = 1.5;
		this.add(minigameCardBacking);

		// minigameCardText_1
		const minigameCardText_1 = scene.add.bitmapText(0, 0, "Aronui", "A");
		minigameCardText_1.scaleX = 1.5;
		minigameCardText_1.scaleY = 1.5;
		minigameCardText_1.setOrigin(0.5, 0.5);
		minigameCardText_1.alpha = 0.5;
		minigameCardText_1.alphaTopLeft = 0.5;
		minigameCardText_1.alphaTopRight = 0.5;
		minigameCardText_1.alphaBottomLeft = 0.5;
		minigameCardText_1.alphaBottomRight = 0.5;
		minigameCardText_1.tintTopLeft = 6896829;
		minigameCardText_1.tintTopRight = 6896829;
		minigameCardText_1.tintBottomLeft = 6896829;
		minigameCardText_1.tintBottomRight = 6896829;
		minigameCardText_1.text = "A";
		minigameCardText_1.fontSize = -28;
		this.add(minigameCardText_1);

		// padding
		const padding = scene.add.nineslice(0, 0, "square-card-positive-outline", undefined, 52, 68, 10, 10, 10, 10);
		padding.scaleX = 1.5;
		padding.scaleY = 1.5;
		padding.visible = false;
		this.add(padding);

		this.minigameCardBacking = minigameCardBacking;
		this.minigameCardText_1 = minigameCardText_1;
		this.padding = padding;

		/* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
	}

	private minigameCardBacking: Phaser.GameObjects.Image;
	private minigameCardText_1: Phaser.GameObjects.BitmapText;
	private padding: Phaser.GameObjects.NineSlice;

	/* START-USER-CODE */
  representingMinigameCard?: StudentGameCard;
  get origin() {
    return this.representingMinigameCard?.origin;
  }

  setRepresentingMinigameCard(StudentGameCard: StudentGameCard) {
    this.representingMinigameCard = StudentGameCard;
    this.setCardText(StudentGameCard.cardText);
    this.setScale(StudentGameCard.targetScale);
  }

  setCardText(text: string) {
    this.minigameCardText_1.setText(text);
    // Resize the card to fit the text.
    const backingSizeX = Math.max(48, this.minigameCardText_1.width + 12);
    const backingSizeY = 64;
    this.minigameCardBacking.setTexture(
      getBackingFromWidth(backingSizeX, false) || 'Card4_48',
    );
    this.padding.setSize(backingSizeX + 4, backingSizeY + 4);
  }

  getDesiredPositionWorld() {
    return {
      x: this.getWorldTransformMatrix().tx,
      y: this.getWorldTransformMatrix().ty,
    };
  }

  getElementSize() {
    return new Phaser.Math.Vector2(
      this.minigameCardBacking.displayWidth,
      this.minigameCardBacking.displayHeight,
    );
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
